/**
 * S3 upload implementation
 *
 * @param post: the post function to call (see index.js)
 * @param file: a blob or file object
 * @param uploadData: contains uploadUrl and uploadParams
 * @param progressCallback: the function to call with the progress value when it changes
 *
 * Returns a promise that will resolve with the url, the source, and optional additional params
 */
const upload = (post, file, uploadData, progressCallback) =>
  new Promise((resolve, reject) => {
    const { uploadUrl, uploadParams } = uploadData;
    const onProgress = progress => {
      progressCallback(progress);
    };

    post(file, uploadUrl, {}, uploadParams, onProgress)
      .then(() => {
        resolve({
          source: 'S3',
          url: uploadData.fileUrl,
          originalUrl: uploadData.fileUrl,
        });
      })
      .catch(reject);
  });
export default upload;
